@if (this.isEditing) {
<kendo-dialog title="Modules Info" width="80%" maxHeight="80%" (close)="this.isEditing = false">
  <kendo-grid [kendoGridBinding]="this.modulesInfo()" class="kendo-grid-custom" [filterable]="'row'" [sortable]="true"
    [pageable]="true" [pageSize]="50">
    <kendo-grid-column field="index" title="Index" [width]="200">
    </kendo-grid-column>
    <kendo-grid-column field="name" title="Naam" [width]="200">
    </kendo-grid-column>
    <!-- <kendo-grid-column field="afdType" title="afdType" [width]="200">
        </kendo-grid-column> -->
    <kendo-grid-column field="afdType" title="Afdeling" [width]="180">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <drop-down-filter [filter]="filter" [data]="this.allAfdTypes()" valueField="afdType"></drop-down-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="type" title="type" [width]="200">
      <ng-template kendoGridFilterCellTemplate let-filter>
        <drop-down-filter [filter]="filter" [data]="this.allTypes" valueField="type"></drop-down-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="modulesStr" title="Modules" [width]="200">
    </kendo-grid-column>
  </kendo-grid>
  <kendo-dialog-actions>
    <button kendoButton (click)="this.isEditing = false" themeColor="primary">
      Close
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
}